import {CommonService} from "./common/commonService";

export class MapToolService {

    static getAllTools = () => (
        CommonService.list("/tools")
    )

    static getTool = (id) => (
        CommonService.list("/tools/" + id)
    )

    static createMapTool = (bean) => (
        CommonService.post("/tools/addMapTool/", bean)
    )

    static editMapTool = (id, bean) => (
        CommonService.update("/tools/editMapTool/" + id, bean)
    )

    static deleteMapTool = (id) => (
        CommonService.delete("/tools/deleteMapTool/" + id)
    )

    static addToolToMap = (bean) => (
        CommonService.post("/mapToolsinMap/addMapToolToMap/" + bean)
    )

    static editToolToMap = (compositeId) => (
        CommonService.update("/mapToolsinMap/editMapToolToMap/" + compositeId)
    )

    static deleteToolFromMap = (compositeId) => (
        CommonService.delete("/mapToolsinMap/deleteMapToolFromMap/" + compositeId)
    )
}